
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import FormResponseViewer from '@/views/Project/Form/components/formResponseViewer.vue'
import InlineUser from '@/views/User/components/inlineUser/inlineUser.vue'
import CourseItem from '@/views/Project/PSI/components/courseItem.vue'
import { SELF_ATTESTABLE_PSI_COURSES_QUERY } from '../gql/queries'
import { Course } from '@/schema'
import PrintResponseButton from '@/views/Project/Form/components/printResponseButton.vue'

const FormResponseViewerDialog = Vue.extend({
    mixins: [ProjectMixin],
    components: { CourseItem, DialogTemplate, FormResponseViewer, InlineUser, PrintResponseButton },
    inheritAttrs: false,

    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            formResponse: this.props.formResponse as null | Record<string, any>,
            completedCourses: [] as Course[],
        }
    },

    computed: {
        resourceFormResponse() {
            return this.props.resourceFormResponse
        },
        formResponseExportFilename() {
            if (!this.props.psi || !this.props.resourceFormResponse) {
                return ''
            }

            return `psi-${this.props.psi.name}-${this.formatDate(
                this.props.resourceFormResponse.time,
                this.getDeviceTimeZone,
                'DD.MM.YYYY HH:mm'
            )}`
        },
    },

    async mounted() {
        try {
            this.isLoading = true
            if (this.props.psi?.useCourses) {
                const { data: coursesData } = await this.$apollo.query({
                    query: SELF_ATTESTABLE_PSI_COURSES_QUERY,
                    variables: {
                        projectId: this.currentProjectId,
                    },
                    fetchPolicy: 'network-only',
                })

                coursesData?.selfAttestablePsiCourses?.forEach((course: Course) => {
                    if (course.myNonExpiredCompletionsForProject.length) {
                        this.completedCourses.push(course)
                    }
                })
            }
        } finally {
            this.isLoading = false
        }
    },
})
export default FormResponseViewerDialog
